module.exports = __webpack_public_path__ + "files/84f7e2d25307ce8b0f69e1b7182e2d5c.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-italic-webfont.eot
 ** module id = 409
 ** module chunks = 0
 **/